import { ArticleCard } from './ArticleCard';
import { useArticles } from '@/hooks/useSupabase';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

interface RelatedArticlesProps {
  currentArticleId: string;
  category: string | null;
  tags: string[] | null;
}

export function RelatedArticles({
  currentArticleId,
  category,
  tags,
}: RelatedArticlesProps) {
  const { t, i18n } = useTranslation('blog');
  const { locale } = useParams<{ locale: string }>();
  const currentLocale = locale || i18n.language || 'fr';

  // Fetch 4 articles max dans la même catégorie (on en exclut 1 = l'article courant)
  const { data: articles } = useArticles({
    category: category || undefined,
    lang: currentLocale,
    limit: 4,
  });

  // Filter out current article and limit to 3
  const relatedArticles = articles
    ?.filter((article) => article.id !== currentArticleId)
    .slice(0, 3);

  if (!relatedArticles || relatedArticles.length === 0) {
    return null;
  }

  return (
    <section className="py-24 bg-aspexit-gray-light">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-8 text-center">
          {t('related.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {relatedArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              category={article.category}
              publishedAt={article.published_at || article.created_at}
              readingTime={article.reading_time}
              featuredImage={article.featured_image}
              isPremium={article.is_premium}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
